import { useMutation, UseQueryResult } from '@tanstack/react-query';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

import {
	updateInvestorDeclarations,
	UpdateInvestorDeclarationsProps,
} from '@dealstack/frontend/shared/dataExchange/services/mip.service';

export const useUpdateInvestorDeclarations = (getKYCDataRequest: UseQueryResult) => {
	const mutation = useMutation<void, Error, UpdateInvestorDeclarationsProps>({
		mutationFn: updateInvestorDeclarations,
	});

	const updateDeclarations = async (data: UpdateInvestorDeclarationsProps) => {
		await mutation.mutateAsync(data, {
			onSuccess: () => {
				void getKYCDataRequest.refetch();

				showToastV2({
					title: 'Updated',
					state: 'success',
				});
			},
		});
	};

	return {
		updateDeclarations,
		mutation,
	};
};
